import type { ActivatedRouteSnapshot, Routes } from '@angular/router';
import {
    CampaignFeature,
    createMetaResolverWithDealer,
    DealerFeature,
    extraDealerTitleResolver,
    ngrxLoaderGuard,
    PageContentType,
} from '@hyundai/ng-common-lib';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { filter, firstValueFrom, map } from 'rxjs';
import DealerCampaignDetailPageComponent from './dealer-campaign-detail-page.component';

export default [
    {
        path: ':campaignSlug',
        component: DealerCampaignDetailPageComponent,
        canActivate: [
            ngrxLoaderGuard({
                actionToDispatch: (route: ActivatedRouteSnapshot) =>
                    CampaignFeature.actions.loadDealerCampaignDetail({ campaignSlug: route.params['campaignSlug'] }),
                waitUntilLoadedSelector: CampaignFeature.state.selectIsLoadingDealerCampaignDetail,
                dataToCheckSelector: CampaignFeature.state.selectDealerCampaignDetail,
                redirectOnFailUrl: (route, store) => {
                    return store.select(DealerFeature.state.selectDealerSlug).pipe(
                        map((slug) => {
                            return `${slug}/404`;
                        }),
                    );
                },
            }),
        ],
        providers: [provideState(CampaignFeature.state), provideEffects([CampaignFeature.effects])],
        title: extraDealerTitleResolver((store) =>
            firstValueFrom(
                store.select(CampaignFeature.state.selectDealerCampaignDetail).pipe(
                    filter((c) => !!c),
                    map((c) => c.teaserHeadline),
                ),
            ),
        ),
        resolve: {
            meta: createMetaResolverWithDealer(async (dealer, store) => {
                const campaignDetail = await firstValueFrom(
                    store.select(CampaignFeature.state.selectDealerCampaignDetail).pipe(filter((c) => !!c)),
                );

                return {
                    description: `${campaignDetail.teaserHeadline} bei ${dealer.name} ${dealer.city}.`,
                };
            }),
        },
        data: {
            contentType: PageContentType.DEALERCAMPAIGNDETAIL,
        },
    },
] satisfies Routes;
